<template>
  <a-modal
    :width="600"
    :visible="visible"
    @cancel="handleCancel"
    :closable="false"
    :title="'转账'"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-alert
          type="info"
          showIcon
          message="此功能会收取1%平台服务费，该费用会从转账数量中自动扣除！"
          style="margin-bottom: 24px;"
        />
        <a-form-item label="收款账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['username', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="收款账户（手机号）"
          />
        </a-form-item>
        <a-form-item label="转账数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            :style="{width:'100%'}"
            v-decorator="['nb_amount', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写"
            :min="1"
            :precision="0"
          />
        </a-form-item>
        <a-form-item label="手机验证" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-input
                type="text"
                placeholder="验证码"
                v-decorator="['captcha', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]"
              ></a-input>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="!state.smsSendBtn && '发送' || (state.time+' s')"
              ></a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit">确定</a-button>
    </template>
    <man-machine ref="manMachine"></man-machine>
  </a-modal>
</template>

<script>
import PropertyAccountApi from '@/api/property-account'
import ProgramApi from '@/api/program'
import ManMachine from '@/components/tools/ManMachine'
export default {
  components: {
    ManMachine
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        smsSendBtn: false
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          PropertyAccountApi.transfer({
            username: values.username,
            nb_amount: values.nb_amount * 100,
            captcha: values.captcha
          })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('转账成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    getCaptcha(e) {
      const { state } = this
      this.$refs.manMachine.start().then(manMachine => {
        const token = manMachine.token
        const hide = this.$message.loading('验证码发送中..', 0)
        ProgramApi.getSmsCaptcha({token:token})
          .then(res => {
            if (res.code === 1) {
              state.smsSendBtn = true
              const interval = window.setInterval(() => {
                if (state.time-- <= 0) {
                  state.time = 60
                  state.smsSendBtn = false
                  window.clearInterval(interval)
                }
              }, 1000)
            } else {
              this.requestFailed(res)
            }
          })
          .catch(err => {
            state.time = 60
            state.smsSendBtn = false
            this.requestFailed(err)
          })
          .finally(() => {
            setTimeout(hide, 1)
          })
      })
    },
    requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: err.message || err.msg || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>
<style lang="less" scoped>
.getCaptcha{
  width: 100%;
}
</style>
